import JSONAPIAdapter from "@ember-data/adapter/json-api";
import { adapterConfig } from "./application";

export default class DataCenterAdapter extends JSONAPIAdapter.extend(adapterConfig) {}
